<template>
    <div>
        <!-- Input Form -->
        <form v-if="!calculated" @submit.prevent="submit">
            <div class="form-group">
                <label>Initial Savings Amount (USD):</label>
                <input
                    type="text"
                    v-model="form.initialSavings"
                    :class="['form-control', form.errors.initialSavings ? 'is-invalid' : '']"
                    placeholder="Enter initial savings"
                />
                <div v-text="form.errors.initialSavings" class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <label>Monthly Deposit (USD):</label>
                <input
                    type="text"
                    v-model="form.monthlyDeposit"
                    :class="['form-control', form.errors.monthlyDeposit ? 'is-invalid' : '']"
                    placeholder="Enter monthly deposit"
                />
                <div v-text="form.errors.monthlyDeposit" class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <label>Annual Interest Rate (%):</label>
                <input
                    type="text"
                    v-model="form.annualRate"
                    :class="['form-control', form.errors.annualRate ? 'is-invalid' : '']"
                    placeholder="Enter annual interest rate"
                />
                <div v-text="form.errors.annualRate" class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <label>Savings Duration (Years):</label>
                <input
                    type="text"
                    v-model="form.durationYears"
                    :class="['form-control', form.errors.durationYears ? 'is-invalid' : '']"
                    placeholder="Enter number of years"
                />
                <div v-text="form.errors.durationYears" class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <button
                    :class="['btn btn-primary btn-block', form.loading ? 'btn-loading' : '']"
                >
                    Calculate
                </button>
            </div>
        </form>

        <!-- Results Section -->
        <div v-if="calculated" class="result-container slide-in-left mt-4">
            <div class="alert alert-info text-center">
                <div class="py-3">
                    <h6 class="font-weight-400">
                        After <b>{{ form.durationYears }}</b> years, your total savings will grow to
                        <b>USD{{ result.finalAmount }}</b>.
                    </h6>
                </div>
            </div>
            <button @click="reset" class="btn btn-secondary btn-block">
                Perform Another Calculation
            </button>
        </div>
    </div>
</template>

<script>
import BillShell from "../../bill-shell.vue";

export default {
    data() {
        return {
            form: {
                initialSavings: "",
                monthlyDeposit: "",
                annualRate: "",
                durationYears: "",
                errors: {}, // Reactive object for form errors
                loading: false,
            },
            calculated: false,
            result: { finalAmount: 0 },
        };
    },
    methods: {
        validateForm() {
            this.form.errors = {};

            if (!this.form.initialSavings || isNaN(this.form.initialSavings) || parseFloat(this.form.initialSavings) < 0) {
                this.form.errors.initialSavings = "Please enter a valid initial savings amount.";
            }

            if (!this.form.monthlyDeposit || isNaN(this.form.monthlyDeposit) || parseFloat(this.form.monthlyDeposit) < 0) {
                this.form.errors.monthlyDeposit = "Please enter a valid monthly deposit amount.";
            }

            if (!this.form.annualRate || isNaN(this.form.annualRate) || parseFloat(this.form.annualRate) <= 0) {
                this.form.errors.annualRate = "Please enter a valid annual interest rate.";
            }

            if (!this.form.durationYears || isNaN(this.form.durationYears) || parseFloat(this.form.durationYears) <= 0) {
                this.form.errors.durationYears = "Please enter a valid duration in years.";
            }

            return Object.keys(this.form.errors).length === 0;
        },

        submit() {
            if (!this.validateForm()) return;

            this.form.loading = true;
            setTimeout(() => {
                const P = parseFloat(this.form.initialSavings);
                const M = parseFloat(this.form.monthlyDeposit);
                const r = parseFloat(this.form.annualRate) / 100 / 12; // Monthly interest rate
                const n = parseFloat(this.form.durationYears) * 12; // Total months

                const futureValue = P * Math.pow(1 + r, n) + M * ((Math.pow(1 + r, n) - 1) / r);

                this.result.finalAmount = futureValue.toFixed(2);
                this.calculated = true; // Toggle calculated to show results
                this.form.loading = false;
            }, 500); // Simulate processing delay
        },

        reset() {
            this.form.initialSavings = "";
            this.form.monthlyDeposit = "";
            this.form.annualRate = "";
            this.form.durationYears = "";
            this.calculated = false; // Toggle calculated to show the form
        },
    },
};
</script>

<style scoped>
@keyframes slideInLeft {
    from {
        transform: translateX(-100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

.slide-in-left {
    animation: slideInLeft 0.5s ease-in-out;
}
</style>
